import { render, staticRenderFns } from "./categoryAdd.vue?vue&type=template&id=5aed7727&"
import script from "./categoryAdd.vue?vue&type=script&lang=js&"
export * from "./categoryAdd.vue?vue&type=script&lang=js&"
import style0 from "./categoryAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports